// extracted by mini-css-extract-plugin
export var level = "strapi-levels-module--level--97246";
export var levelDescription = "strapi-levels-module--levelDescription--868ac";
export var levelWrapper = "strapi-levels-module--levelWrapper--a3afc";
export var levels = "strapi-levels-module--levels--dc758";
export var root = "strapi-levels-module--root--41b45";
export var selectedBackgroundWrapper = "strapi-levels-module--selectedBackgroundWrapper--bf9cf";
export var selectedLevel = "strapi-levels-module--selectedLevel--25a3e";